import React from "react";
import { motion } from "framer-motion";

const services = [
    {
        num: "01",
        title: "Marketing & Events",
        desc: "Monthly revenue-driving events, seasonal offers, email + SMS campaigns, and the marketing playbook to fill seats and grow your check averages.",
        points: ["Event concept dev", "Email + SMS campaigns", "Social strategy", "Performance tracking"],
    },
    {
        num: "02",
        title: "Revenue Programs",
        desc: "Loyalty programs, subscription clubs, and recurring revenue offerings — built end-to-end with SOPs, sales copy, and staff training.",
        points: ["Loyalty programs", "Subscription clubs", "POS setup", "Launch campaigns"],
    },
    {
        num: "03",
        title: "Operations & Strategy",
        desc: "Targeted consulting for owners and operators: pricing, menu engineering, systems cleanup, HR, brand, and everything in between.",
        points: ["Menu engineering", "SOP creation", "Systems setup", "Brand strategy"],
    },
];

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="py-24 md:py-32 bg-brand-cream"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-4 flex items-center gap-4">
                        <span className="h-px w-10 bg-brand-orange" />
                        <span className="text-xs uppercase tracking-[0.3em] text-brand-orange font-medium">
                            What We Do
                        </span>
                    </div>
                    <h2
                        data-testid="services-headline"
                        className="col-span-12 md:col-span-8 font-serif text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight text-brand-dark"
                    >
                        Built for the way hospitality
                        <br />
                        <span className="italic text-brand-muted">actually makes money.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 border-t border-brand-border-light">
                    {services.map((s, i) => (
                        <motion.article
                            key={s.num}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            data-testid={`service-card-${i}`}
                            className={`group py-10 md:py-14 px-2 md:px-8 border-b border-brand-border-light md:border-b-0 ${
                                i < 2 ? "md:border-r md:border-brand-border-light" : ""
                            } hover:bg-white transition-colors duration-500`}
                        >
                            <div className="flex items-baseline justify-between mb-6">
                                <span className="font-serif text-brand-orange text-5xl italic">
                                    {s.num}
                                </span>
                                <span className="h-px flex-1 mx-4 bg-brand-border-light" />
                            </div>
                            <h3 className="font-serif text-3xl md:text-4xl text-brand-dark mb-4 leading-tight">
                                {s.title}
                            </h3>
                            <p className="text-brand-muted leading-relaxed mb-6">{s.desc}</p>
                            <ul className="space-y-2">
                                {s.points.map((p) => (
                                    <li
                                        key={p}
                                        className="text-sm text-brand-dark flex items-center gap-3"
                                    >
                                        <span className="w-1.5 h-1.5 bg-brand-orange" />
                                        {p}
                                    </li>
                                ))}
                            </ul>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
